__turbopack_context__.v({
  "AltText": "figure-module__rwxCpq__AltText",
  "FabButton": "figure-module__rwxCpq__FabButton",
  "FullImage": "figure-module__rwxCpq__FullImage",
  "ImageWrapper": "figure-module__rwxCpq__ImageWrapper",
  "ImageWrapperStatement": "figure-module__rwxCpq__ImageWrapperStatement",
  "LightboxBackdrop": "figure-module__rwxCpq__LightboxBackdrop",
  "LightboxContent": "figure-module__rwxCpq__LightboxContent",
  "LightboxWrapper": "figure-module__rwxCpq__LightboxWrapper",
  "Ligntbox": "figure-module__rwxCpq__Ligntbox",
  "LigntboxContent": "figure-module__rwxCpq__LigntboxContent",
});
